import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Chips, GradientMark, PageHeader } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentUi';
import { useStudent } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentContext';
import { STUDENT_BASE, jobs } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Job = () => {
  const navigate = useNavigate();
  const { chips, saved, markSaved } = useStudent();
  const visible = jobs.filter((job) => chips.jobs === 'All' || job.type === chips.jobs);

  return (
    <>
      <PageHeader
        title="Jobs & Internships"
        right={<button type="button" className="sa-ib" aria-label="Filter"><Icon name="filter" /></button>}
      />
      <Chips group="jobs" options={['All', 'Jobs', 'Internship']} />
      <div className="sa-card sa-row sa-search">
        <Icon name="search" />
        <span>Search jobs, internships…</span>
      </div>
      {visible.map((job) => {
        const applied = Boolean(saved[job.id]);
        return (
          <div className="sa-card sa-item" key={job.id}>
            <GradientMark name={job.icon} from={job.from} to={job.to} />
            <div className="sa-sp">
              <div className="sa-b" style={{ fontSize: 14 }}>{job.title}</div>
              <div className="sa-mut">{job.company}</div>
              <div className="sa-mut" style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                <Icon name="pin" /> {job.meta}
              </div>
              {job.tags.map((tag) => <span className="sa-tag" key={tag}>{tag}</span>)}
            </div>
            <button
              type="button"
              className={`sa-btn${applied ? ' ok' : ''}`}
              onClick={() => markSaved(job.id, 'Application started')}
            >
              {applied ? 'Applied' : 'Apply'}
            </button>
          </div>
        );
      })}
      <div className="sa-card sa-row sa-nudge">
        <Icon name="user" />
        <div className="sa-sp">
          <div className="sa-b" style={{ fontSize: 12 }}>Not getting relevant jobs?</div>
          <div className="sa-mut">Update your profile & skills</div>
        </div>
        <button type="button" className="sa-btn" onClick={() => navigate(`${STUDENT_BASE}/profile`)}>Update now</button>
      </div>
    </>
  );
};

export default Job;
